export default __webpack_public_path__ + "static/media/discover_menu.beed0716.svg";